import { createContext } from 'react';
const DestinationsContext = createContext();
export default DestinationsContext;
